import { TColor } from '@dw/models/shared';

export const getSpacingCss = (spacing: number): string => `var(--dw-spacing-${spacing})`;

export const getColorCss = (color: TColor, opacity?: number): string => {
  if (opacity !== undefined) {
    return `rgba(var(--color-${color}-rgb), ${opacity})`;
  } else {
    return `var(--color-${color})`;
  }
}

export const normaliseCssDistance = (distance: number | string | undefined): string | undefined =>
  distance === undefined ? undefined : typeof distance === 'number' ? `${distance}px` : distance;

export const clampCss = (min: string | number, preferred: string | number, max: string | number = '100vw') => `clamp(${normaliseCssDistance(min)}, ${normaliseCssDistance(preferred)}, ${normaliseCssDistance(max)})`;